import script from "./VeBalTooltipExplainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VeBalTooltipExplainer.vue?vue&type=script&setup=true&lang=ts"

import "./VeBalTooltipExplainer.vue?vue&type=style&index=0&id=577808b1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577808b1"]])

export default __exports__